module.exports = __webpack_public_path__ + "7bbf7f77d804919aedf359acc3e4c22b.png";